module.exports = __webpack_public_path__ + "static/media/flag_spain.e511dcee.svg";